var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSegEnterpriseTier = function SvgSegEnterpriseTier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1010 10A10.002 10.002 0 0012 2zm-.521 18.016v-6.272H7.992l5.01-9.76v6.272h3.357z"
  })));
};
export default SvgSegEnterpriseTier;